var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('table',{ref:"tableuser",staticClass:"table table-hover"},[_vm._m(0),_c('tbody')])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Name")]),_c('th',[_vm._v("Username")]),_c('th',[_vm._v("Email")]),_c('th',[_vm._v("Group")])])])
}]

export { render, staticRenderFns }